// API routes config
const localhost = false
const origin = window.location.origin
const development = localhost ? 'http://localhost:8000/api' : 'https://marketplace.pulsawork.com/api'
const API_URL = origin === 'http://localhost:5173' ? development : window.location.origin + '/api'

export const API = {
    USER_ME: API_URL + '/auth/users/me/',
    LOGIN: API_URL + '/login/',
    REFRESH: API_URL + '/auth/jwt/refresh/',
    VERIFY: API_URL + '/auth/jwt/verify/',
    REGISTER: API_URL + '/public/user_register/',
    ACTIVATION: API_URL + '/auth/users/activation/',
    RESEND_ACTIVATION: API_URL + '/auth/users/resend_activation/',
    RESET_PASSWORD: API_URL + '/auth/users/reset_password/',
    RESET_PASSWORD_CONFIRM: API_URL + '/auth/users/reset_password_confirm/',
    SET_PASSWORD: API_URL + '/auth/users/set_password/',
    COMPANIES: API_URL + '/core/companies/',
    COMPANY_REQUESTS: API_URL + '/admin/requests/',
    ADMIN_USERS: API_URL + '/admin/users/',
    COMPANY_VERIFICATION_REQUESTS: API_URL + '/core/company_verification_requests/',
    ATTACHMENTS: API_URL + '/core/attachments/',
    ATTACHMENTS_BULK: API_URL + '/core/attachments/bulk/',
    OFFERS: API_URL + '/core/rfqs/',
    ORDERS: API_URL + '/core/rfqs/orders/',
    BIDS: API_URL + '/core/rfq_bids/',
    BIDS_ACTION: API_URL + '/core/rfq_bids/action/',
    BIDS_STATS: API_URL + '/core/list_stats/rfq/bids/',
    CHOICES: API_URL + '/core/choices/',
    INDUSTRY_SPECIALIZATION: API_URL + '/core/industry_specializations/',
    REQUIREMENT_TYPES: API_URL + '/core/rfq_requirement_types/',
    RFQ_PROCEDURES: API_URL + '/core/rfq_procedures/',
    ONE_WORD_DESCRIPTIONS: API_URL + '/core/one_word_descriptions/',
    SERVICES_OFFERED: API_URL + '/core/services_offered/',
    CLIENT_CHARGE_TYPES: API_URL + '/core/client_charge_types/',
    MOST_COMMON_CONTRACT_TYPES: API_URL + '/core/most_common_contract_types/',
    FULFILLMENTS: API_URL + '/core/fulfillment_data/',
    EXPORT_FULFILLMENTS: API_URL + '/export/fulfillment_data/',
    IMPORT_FULFILLMENTS: API_URL + '/export/fulfillment_data/import/',
    CLAIMS: API_URL + '/core/claims/',
    DISPUTES: API_URL + '/core/disputes/',
    PAYMENT_RECORDS: API_URL + '/core/payment_records/',
    INVOICES: API_URL + '/invoices/',
    RFQ_STATS: API_URL + '/core/stats/rfq/',
    FULFILLMENTS_STATS: API_URL + '/core/list_stats/fulfillments/',
    DISPUTES_STATS: API_URL + '/core/list_stats/disputes/',
    CLAIMS_STATS: API_URL + '/core/list_stats/claims/',
    PAYMENT_RECORDS_STATS: API_URL + '/core/list_stats/payment_records/',
    ACTIVE_ORDERS_STATS: API_URL + '/core/list_stats/rfq/active_orders/',
    ACTIVE_OFFERS_STATS: API_URL + '/core/list_stats/rfq/list/',
    NOTIFICATIONS: API_URL + '/notifications/',
    NOTIFICATIONS_READ_ALL: API_URL + '/notifications/read_all/',
    NOTIFICATIONS_BULK: API_URL + '/notifications/bulk/',
}